import axios from 'axios'
import {ResponseObject, ResponseObjectPaginated, ResponseObjectUpload} from '../../../models'
import {
  CleaningScheduleBodyDto,
  ServiceSchedulingDto,
  ServiceSchedulingFilterModel,
} from '../model/cleaningSchedule.model'
const BASEURL = process.env.REACT_APP_DEV_API_LIMPIEZA_URL

export const CLEANING_SCHEDULE_SERVICES = {
  createCleaningSchedule: async (dto: CleaningScheduleBodyDto) => {
    return await axios.post<any>(`${BASEURL}/serviceScheduling/create`, dto)
  },
  editCleaningSchedule: async (dto: CleaningScheduleBodyDto) => {
    return await axios.post<ResponseObjectUpload>(`${BASEURL}/serviceScheduling/update`, dto)
  },
  filterCleaningSchedule: async (dto: ServiceSchedulingFilterModel) => {
    return await axios.post<ResponseObjectPaginated<ServiceSchedulingDto[]>>(
      `${BASEURL}/serviceScheduling/filter`,
      dto,
    )
  },
  getByIdCleaningSchedule: async (id: string | undefined | number) => {
    return await axios.get<ResponseObject<ServiceSchedulingDto>>(
      `${BASEURL}/serviceScheduling/getById`,
      {params: {id}},
    )
  },
  deleteActivitySettings: async (id: string | undefined | number) => {
    return await axios.delete<any>(`${BASEURL}/serviceScheduling/deleteActivitySettings`, {
      params: {id},
    })
  },
  deleteCleaningSchedule: async (id: string | undefined | number) => {
    return await axios.delete<ResponseObjectUpload>(`${BASEURL}/serviceScheduling/delete`, {
      params: {id},
    })
  },
}
